import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { EditLinkButton } from 'shared/mui/Buttons';
import { ShowPage } from 'shared/react-admin/Pages/ShowPage/ShowPage';
import { Permission } from 'types/embedded/permission';

import { RolesShowTable } from './RolesShowTable';

export const RolesShow: React.FC = () => {
  const { hasResourcePermissions } = usePermissions();

  return (
    <ShowPage
      listName="Роли"
      rightActionsSlot={[
        hasResourcePermissions(Resources.Roles, [Permission.Full, Permission.Update]) && (
          <EditLinkButton key="edit-button" label="Редактировать" variant="contained" />
        ),
      ]}
      title="Просмотр роли"
    >
      <RolesShowTable />
    </ShowPage>
  );
};
